import { BoxProps, Heading, Text } from "@chakra-ui/react"
import React from "react"

interface Props extends BoxProps {
  orderNumber?: string
}

const FormHeading: React.FC<Props> = ({ orderNumber, children, ...rest }) => {
  return (
    <Heading
      as="h4"
      display="flex"
      fontSize="xl"
      mb={4}
      textTransform="capitalize"
      {...rest}
    >
      {orderNumber && (
        <Text fontWeight="bold" px={2} mr={2} background="gray.300">
          {orderNumber}
        </Text>
      )}
      {children}
    </Heading>
  )
}

export default FormHeading
